import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useOrgFilter } from "./OrgFilterContext";
import "@/styles/social-plane.css";

const SOCIAL = "social";

function isAuthChromePath(pathname = "") {
  return (
    pathname === "/login" ||
    pathname === "/signup" ||
    pathname === "/about" ||
    pathname === "/invite" ||
    pathname.startsWith("/invite/")
  );
}

/**
 * Applies warm light Circa Social tokens on documentElement while the user
 * is in the Social workspace. Cleared immediately when an org is selected.
 * Auth chrome (invite/login/signup/about) stays on dark Circa tokens.
 */
export function SocialPlaneThemeProvider({ children }) {
  const { selectedOrgId, workspaceUpdating } = useOrgFilter();
  const location = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    const isSocial =
      !isAuthChromePath(location.pathname) &&
      !workspaceUpdating &&
      (!selectedOrgId || selectedOrgId === SOCIAL);

    if (isSocial) {
      root.setAttribute("data-social-plane", "");
    } else {
      root.removeAttribute("data-social-plane");
    }

    return () => {
      root.removeAttribute("data-social-plane");
    };
  }, [selectedOrgId, workspaceUpdating, location.pathname]);

  return children;
}
